import gql from "graphql-tag";

export const GET_AREAGROUPS = gql`
 query areaGroups($cityId:uuid!){
  areaGroups (where: {cityId: {_eq: $cityId}}){
    id
    name
    cityId
    City{id city}
    }
}`
export const GET_ALL_AREAGROUPS = gql`
 query areaGroups{
  areaGroups{
    id
    name
  }
}`
